import { AnyAction } from 'redux';

import { LocationsReceivedAction, LOCATIONS_RECEIVED } from '@ttstr/actions/locations';
import { Article, Articles, IndexedLocations, LocationType } from '@ttstr/api';
import { AppState } from '.';

export interface ReduxState {
  locationsReceived: boolean;
  locations: IndexedLocations;
}

const initialState: ReduxState = {
  locationsReceived: false,
  locations: {},
};

const locations = (state: ReduxState = initialState, action: AnyAction): ReduxState => {
  switch (action.type) {
    case LOCATIONS_RECEIVED: {
      const { locations } = (action as LocationsReceivedAction).payload;

      if (!locations) return state;

      return {
        ...state,
        locationsReceived: true,
        locations: locations.reduce(
          (previous, current) => ({
            ...previous,
            [current.id]: current,
          }),
          {}
        ),
      };
    }
    default:
      return state;
  }
};

export const getLocations = (state: AppState) => {
  return state.Locations.locations;
};

export const getLocationsReceived = (state: AppState) => {
  return state.Locations.locationsReceived;
};

export const getLocationFromProduct = (locations: IndexedLocations, product: Article) => {
  return locations[product.location_id] || ({} as LocationType);
};

export const getLocationsForProducts = (locations: IndexedLocations, products: Articles) => {
  if (!locations) return {};
  return Object.entries(locations).reduce<IndexedLocations>(
    (acc, [id, location]) => (products.some((p) => p.location_id === Number(id)) ? { ...acc, [id]: location } : acc),
    {}
  );
};

export default locations;
